import React from "react";
import ParentFormLabel from "react-bootstrap/esm/FormLabel";
import type { FormLabelProps } from "react-bootstrap/esm/FormLabel";

const FormLabel: React.FC<FormLabelProps> = (props) => (
  <ParentFormLabel {...props} />
);

export default FormLabel;
